export const DEFAULTS = {
  alignment: 'center',
  size: 'content',
};

export const REMOVE_LINK_PREVIEW = 'remove-link-preview';
